<template>
  <div class="achievements_item swiper-slide" @mouseenter="mouseOver" @mouseleave="mouseOver">
    <span class="achievements_sum" v-text="totalSum.toLocaleString('ru')" />
    <span class="achievements_description">
      <slot></slot>
    </span>

    <span class="achievements_info">i</span>
    <Transition name="achievements_tooltip-animate">
      <div class="achievements_tooltip" v-show="showTooltip">
        <slot name="tooltip-text">
          <p>
            {{ $t("Расплачивайся картой чаще и возвращай еще больше золота") }}
          </p>
        </slot>
      </div>
    </Transition>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
// import { GAME_NAMES } from '@/constants'

@Component
class Achievement extends Vue {
  @Prop({ type: Number, required: true }) totalSum
  // @Prop({ type: Object }) sumByGames

  showTooltip = false

  /* Until better times (i love our customers)
  get showGamesInfo () {
    return Object.keys(this.sumByGames).length > 1
  }

  gameName (game) {
    return GAME_NAMES[game]
  }
  */

  mouseOver () {
    this.showTooltip = !this.showTooltip
  }
}

export default Achievement
</script>
